import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useOverlayContext } from 'seagull';
import BillClientModal from '~/components/BillClientModal/BillClientModal';
import GlobalBillModal from '~/components/GlobalBillModal/GlobalBillModal';
import { useStoreActions } from '~/store/store-context';
export function useGlobalBillClient() {
    const { showModal } = useOverlayContext();
    const { logBI } = useStoreActions();
    const handleOpenBillClient = async (context)=>{
        showModal({
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(BillClientModal, _object_spread({
                    dismissModal: dismissModal
                }, context));
            }
        });
    };
    return {
        openGlobalBillModal: ()=>{
            logBI(10351);
            showModal({
                closeOnClickOutside: true,
                closeOnEscapeKey: true,
                content: (param)=>{
                    let { dismissModal } = param;
                    return /*#__PURE__*/ _jsx(GlobalBillModal, {
                        dismissModal: dismissModal,
                        handleOpenBillClient: handleOpenBillClient
                    });
                }
            });
        }
    };
}
